import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject,
    SoundType
} from "@denishussar/html5-game-engine";
import {GameLogic} from "../../Logic/GameLogic";
import {GameModalsEnum, GameModel} from "../../Models/GameModel";
import {ButtonController, IButtonControllerOptions} from "../Common/ButtonController";
import {SoundConstants} from "../../Constants/SoundConstants";

export class GameTopMenuController extends AnimationBaseController {
    $model: GameModel;
    private buttonSoundOff: ButtonController;
    private buttonSoundOn: ButtonController;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _fullScreenManager: FullScreenManager) {
        super("GameTopMenuController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers:{
                buttonFullScreen: {
                    instanceName: "button_fullscreen",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{

                            if (this._fullScreenManager.isEnabled) {
                                this._fullScreenManager.toggleGame();
                            }
                        }
                    }
                },
                buttonPause: {
                    instanceName: "button_pause",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.pause();
                        }
                    }
                }
            },
            modelWatch: {
                modalState: (state: GameModalsEnum) => {
                    this.$childControllers.get<ButtonController>('buttonPause').visible = (state === GameModalsEnum.none);
                }
            }
        };
    }

    protected onInitialize(): void {
        this.$childControllers.get<ButtonController>("buttonFullScreen").visible = this._fullScreenManager.isEnabled;
        this.$childControllers.get<ButtonController>('buttonPause').visible = (this.$model.modalState === GameModalsEnum.none);

    }

    protected onResize(width: number, height: number, scale: number): void {
        // this.y = -height/scale/2;
        // this.x = -width/scale/2;
    }

}

